import React, { useState } from 'react';
import { CampaignItemIcon } from '../../../../Sidebar/icons';
import ConfirmModal from '../../components/ConfirmModal';

/**
 * NestedSprintIndicator Component
 * 
 * Shows a nested sprint button with progress for a task node.
 * Includes a delete button to remove the nested campaign.
 */
const NestedSprintIndicator = ({
  nestedSprint,
  creating = false,
  onOpenNestedSprint,
  onRemoveNestedSprint,
}) => {
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  if (creating) {
    return (
      <div className="task-node__nested-sprint-container">
        <span className="mission-card__date-row-label">Nested Campaign:</span>
        <div
          className="task-node__nested-sprint task-node__nested-sprint--creating"
          aria-live="polite"
          aria-busy="true"
        >
          <span className="task-node__nested-sprint-icon">
            <span className="task-node__nested-sprint-spinner" aria-hidden="true" />
          </span>
          <div className="task-node__nested-sprint-middle">
            <span className="task-node__nested-sprint-label">Creating campaign</span>
            <div className="task-node__nested-sprint-progress" />
          </div>
        </div>
      </div>
    );
  }

  if (!nestedSprint) return null;

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    setShowDeleteConfirm(true);
  };

  const handleConfirmDelete = () => {
    setShowDeleteConfirm(false);
    onRemoveNestedSprint?.();
  };

  const progress = nestedSprint.progress || 0;

  return (
    <div className="task-node__nested-sprint-container">
      <span className="mission-card__date-row-label">Nested Campaign:</span>
      
      <button
        className="task-node__nested-sprint"
        onClick={(e) => {
          e.stopPropagation();
          onOpenNestedSprint?.(nestedSprint);
        }}
        onMouseDown={(e) => e.stopPropagation()}
        title={`Open nested campaign: ${nestedSprint.name}`}
      >
        {/* Left column: icon */}
        <span className="task-node__nested-sprint-icon">
          <CampaignItemIcon size={12} />
        </span>
        
        {/* Middle column: name + progress bar */}
        <div className="task-node__nested-sprint-middle">
          <span className="task-node__nested-sprint-label">{nestedSprint.name}</span>
          <div className="task-node__nested-sprint-progress">
            <div 
              className={`task-node__nested-sprint-progress-fill${progress === 100 ? ' task-node__nested-sprint-progress-fill--complete' : ''}`}
              style={{ width: `${progress}%` }}
            />
          </div>
        </div>
        
        {/* Right column: delete button */}
        <span
          className="task-node__nested-sprint-delete"
          onClick={handleDeleteClick}
          onMouseDown={(e) => e.stopPropagation()}
          title="Move to trash"
          role="button"
          tabIndex={0}
        >
          ×
        </span>
      </button>

      <ConfirmModal
        isOpen={showDeleteConfirm}
        title="Move to Trash"
        message={`Move "${nestedSprint.name}" to trash? The mission itself stays — it just won't contain a nested campaign anymore. You can restore the campaign later from the Trash.`}
        confirmLabel="Move to Trash"
        cancelLabel="Cancel"
        confirmVariant="warning"
        icon="🗑"
        onConfirm={handleConfirmDelete}
        onCancel={() => setShowDeleteConfirm(false)}
      />
    </div>
  );
};

export default NestedSprintIndicator;

